/**
* @name APP u-Planning
* @autor vignesh.somayaji@u-planner.com
* @description
* Descripcion del controlador
* @controller 
* # name: teacherSelfAssessmentController
* # alias: Ctrl
*/

export default class teacherSelfAssessmentController {

  constructor($scope, $state, $stateParams, ngNotify, $timeout, UserInfoConstant,integralEvaluationSrv,$cookies,GlobalConfig,WorkPlanSrv,$mdDialog,$location,$anchorScroll) {
    var selfAss=this
    this.$state = $state
    this.$scope = $scope
    this.$stateParams = $stateParams
    this.ngNotify = ngNotify
    this.$timeout = $timeout
    this.integralEvaluationSrv=integralEvaluationSrv
    this.GlobalConfig=GlobalConfig
    this.$mdDialog=$mdDialog
    this.assignation=[]
    this.imageLoader=require('./simplespin.gif')
    this.$location=$location
    this.$anchorScroll=$anchorScroll


    this.teachingId=1;
    this.teacherWorkPlanId=2;
    this.commitmentId=3;
    this.openQuestionsId=4;
    this.finalConceptId=5;
    this.TotalProgressPercentage={1:0,2:0,3:0,4:0,5:0}
    this.id_code_evaluationmenues=[1,2,3,4,5]
    this.percentageBarActualTotal={}
    this.percentageBarTotal={}

    this.finalConceptTooltip={
      17:'El profesor desarrolló plenamente las actividades en el plan de trabajo. La calidad de su trabajo y de los resultados de la apreciación de los estudiantes fue excelente.',
      18:'El profesor desarrolló las actividades en el plan de trabajo. La calidad de su trabajo y de los resultados de la apreciación de los estudiantes fue muy buena.',
      19:'** El profesor desarrolló las actividades relacionadas con las responsabilidades a su cargo establecidas en el plan de trabajo, surgen comentarios frente al nivel de desarrollo en el alguna(s) de ella(s). La calidad de su trabajo y de los resultados de la apreciación de los estudiantes fue buena.',
      20:'El profesor logró demostrar desarrollos aceptables y se identifican deficiencias en las actividades en el plan de trabajo. La calidad de su trabajo y de los resultados de la apreciación de los estudiantes son aceptables.',
      21:'El profesor no logró los objetivos propuestos, aunque demostró cierto nivel de desarrollo de las actividades en el plan de trabajo. La calidad de su trabajo y de los resultados de la apreciación de los estudiantes fue insuficiente.'
    }





    this.$scope.UserInfoConstant = UserInfoConstant
    this.$scope.$watch('UserInfoConstant[0].details[0]', (details) => {
      if (details !== undefined) {
        this.userinfo = details.user
        this.cookiesUser = $cookies.get('currentUser') ? JSON.parse($cookies.get('currentUser')) : false
        this.main()
      }
    })

   $scope.flags='teaching'
    $scope.teaching = function(id){
      $scope.flags=id
    };


  }



  main() {
    console.log('Estoy en el controlador de teacherSelfAssessmentController')
    this.activeParam()
  }

  activeParam(){

   console.log('sample try ',this.cookiesUser)
       //this.cookiesUser.teacherId

       var param={id_teacher:this.cookiesUser.teacherId,id_work_plan:this.cookiesUser.workplanId,options:'AUTO'}

       var THIS=this
       this.integralEvaluationSrv.asignaturesDetails.getAsignaturesDetails(param).$promise.then(function (dataReturn) {
        if (dataReturn.status) {


         THIS.reflection={}
         THIS.trabajo={}
         THIS.compromise={}
         THIS.TotalQuestion={}


         for(var i in dataReturn.data.reflexion){
          var count=0;

          for(var j in dataReturn.data.reflexion[i].values){
            if(dataReturn.data.reflexion[i].values[j].values!=''){
              count++
            }
            THIS.reflection[dataReturn.data.reflexion[i].values[j].id]=dataReturn.data.reflexion[i].values[j].values
          }
          dataReturn.data.reflexion[i].percentage=(count/dataReturn.data.reflexion[i].values.length)*100
        }

        for(var i in dataReturn.data.evaluation){
          if(typeof THIS.percentageBarActualTotal[dataReturn.data.evaluation[i].id_code_evaluationmenues] ==='undefined'){
            THIS.percentageBarActualTotal[dataReturn.data.evaluation[i].id_code_evaluationmenues]=0
            THIS.percentageBarTotal[dataReturn.data.evaluation[i].id_code_evaluationmenues]=0
          }

          if(dataReturn.data.evaluation[i].id_code_evaluationmenues==2 | dataReturn.data.evaluation[i].id_code_evaluationmenues==4){
           THIS.trabajo[dataReturn.data.evaluation[i].id_code_questions]=dataReturn.data.evaluation[i].text
            if(dataReturn.data.evaluation[i].text!=''){
               THIS.TotalQuestion[dataReturn.data.evaluation[i].id_code_questions]=dataReturn.data.evaluation[i].text
               THIS.percentageBarActualTotal[dataReturn.data.evaluation[i].id_code_evaluationmenues]+=1
            }
            THIS.percentageBarTotal[dataReturn.data.evaluation[i].id_code_evaluationmenues]+=1
             
         }
       }

       for(var i in dataReturn.data.options){

         if(typeof THIS.percentageBarActualTotal[dataReturn.data.options[i].id_code_evaluationmenues] ==='undefined'){
            THIS.percentageBarActualTotal[dataReturn.data.options[i].id_code_evaluationmenues]=0
            THIS.percentageBarTotal[dataReturn.data.options[i].id_code_evaluationmenues]=0
          }

        THIS.trabajo[dataReturn.data.options[i].id_code_questions]=dataReturn.data.options[i].text 
        for(var j in dataReturn.data.options[i].value){

          if(dataReturn.data.options[i].value[j].values==dataReturn.data.options[i].value[j].id_code_options){
           THIS.TotalQuestion[dataReturn.data.options[i].id_code_questions]=dataReturn.data.options[i].value[j].id_code_options
           THIS.compromise[dataReturn.data.options[i].value[j].optionPlaceholder]=dataReturn.data.options[i].value[j].id_code_options
            THIS.percentageBarActualTotal[dataReturn.data.options[i].id_code_evaluationmenues]+=1
         }else{
           THIS.compromise[dataReturn.data.options[i].value[j].optionPlaceholder]=false
         }

       }
         THIS.percentageBarTotal[dataReturn.data.options[i].id_code_evaluationmenues]+=1
     }



     THIS.assignation=dataReturn.data
     THIS.docencia=dataReturn.data.evaluation[0].text

      THIS.$timeout( function(){

        var countRef=0

        for(var i in THIS.assignation.reflexion){
          var assignature=THIS.assignation.reflexion[i].id_code_asignature
          countRef+=parseInt(THIS.assignation.reflexion[i].percentage)
          $('#progress-'+assignature).css('width',parseInt(THIS.assignation.reflexion[i].percentage)+'%')
        }

        if(THIS.docencia!=''){
           countRef+=100
         }


        var reflexCount=(countRef/parseInt(THIS.assignation.reflexion.length+1))
        THIS.TotalProgressPercentage[THIS.teachingId]=reflexCount
        THIS.TotalProgressPercentage[THIS.teacherWorkPlanId]=(THIS.percentageBarTotal[THIS.teacherWorkPlanId]/THIS.percentageBarTotal[THIS.teacherWorkPlanId])*100
        THIS.TotalProgressPercentage[THIS.commitmentId]=(THIS.percentageBarTotal[THIS.commitmentId]/THIS.percentageBarTotal[THIS.commitmentId])*100
        THIS.TotalProgressPercentage[THIS.openQuestionsId]=(THIS.percentageBarTotal[THIS.openQuestionsId]/THIS.percentageBarTotal[THIS.openQuestionsId])*100
        THIS.TotalProgressPercentage[THIS.finalConceptId]=(THIS.percentageBarTotal[THIS.finalConceptId]/THIS.percentageBarTotal[THIS.finalConceptId])*100

         
      }, 500 );



   }
 },function (data) {
  console.log('sample vignesh',data)
}
)
}


 checkTotalPercentage(id_question,id){

        var param={id_teacher:this.cookiesUser.teacherId,
                   id_work_plan:this.cookiesUser.workplanId,
                   options:'AUTO'}
        var THIS=this;
        this.integralEvaluationSrv.getTotalPercentageOfEnteredData.getTotal(param).$promise.
        then(function (dataReturn) {
        if (dataReturn.status) {
           console.log('ttttt',dataReturn)
           THIS.TotalProgressPercentage=dataReturn.data
        }

        },function (data) {
        console.log('sample vignesh',data)
        }
        )

 }


     teacherTextareaOnBlur(id_question,id,event,id_code_asignature){
      var id_assignations=null

      

      if(id_question==1){

        var id_assignations=null
        var text=this.docencia

      }else if(id_question==2){

        var id_assignations=id
        var text=this.reflection[id]


        for(var i in this.assignation.reflexion){
            var count=0;
                if(id_code_asignature==this.assignation.reflexion[i].id_code_asignature){
                  for(var j in this.assignation.reflexion[i].values){

                    if(this.reflection[this.assignation.reflexion[i].values[j].id]!=''){
                      count++
                    }

                  }
                  this.assignation.reflexion[i].percentage=(count/this.assignation.reflexion[i].values.length)*100
                  $('#progress-'+id_code_asignature).css('width',parseInt(this.assignation.reflexion[i].percentage)+'%')
                }
          }



            }else {//if(id_question==3 || id_question==4 || id_question==5 || id_question==6 || id_question==7){
              var text=this.trabajo[id_question]
            }



            if(id=='options'){

              var id_code_options=$('input[name=radio-'+id_question+']:checked').val();
              var param={
                id_question:id_question,
                ds_description:text,
                id_work_plan_teacher:this.assignation.userDetails.id_workplan_teacher,
                id_assignations:id_assignations,
                id_option:id_code_options
              }

            }else{

              var param={
                id_question:id_question,
                ds_description:text,
                id_work_plan_teacher:this.assignation.userDetails.id_workplan_teacher,
                id_assignations:id_assignations
              }

            }

            $('#imag-loader').css('top','50%')
            $('#imag-loader').css('left','50%')
            $('#imag-loader-screen').show()
            var THIS=this

            if($.trim(text)!=''){
              this.integralEvaluationSrv.asignaturesSave.updateAssignationValue(param).$promise.then(function (dataReturn) {
                $('#imag-loader-screen').hide()
                THIS.checkTotalPercentage()
              }, function (data) {
                $('#imag-loader-screen').hide()
                console.log('error',data)
              }
              )
            }else{
              $('#imag-loader-screen').hide()
            }
      }

      optionSave(id_code_options,id_question,id_code_evaluationmenues,event){

                  var param={
                    id_question:id_question,
                    ds_description:typeof this.trabajo[id_question]==='undefined' ? null : this.trabajo[id_question],
                    id_work_plan_teacher:this.assignation.userDetails.id_workplan_teacher,
                    id_option:id_code_options,
                  }

                  console.log(param)

                // alert(window.innerWidth + ' × ' + $('.content-box').scrollHeight);


                // $('#imag-loader').css('top',event.screenY+100 )
                // $('#imag-loader').css('left',event.screenX)

                $('#imag-loader').css('top','50%')
                $('#imag-loader').css('left','50%')
                //$('#imag-loader-screen').show()

                var THIS=this
                this.integralEvaluationSrv.asignaturesSave.updateAssignationValue(param).$promise.then(function (dataReturn) {


                 $('#imag-loader-screen').hide()

               }, function (data) {
                console.log('error',data)
                $('#imag-loader-screen').hide()
              }
              )

    }



    endPlanning(){

     var param={id_teacher:this.cookiesUser.teacherId,id_work_plan:this.cookiesUser.workplanId}

     var THIS=this

     this.integralEvaluationSrv.getMandatoryData.getMandatoryDataFlag(param).$promise.then(function (dataReturn) {
      if (dataReturn.status) {

        if(dataReturn.data.flag==true){
         THIS.endProcessModal()
       }else{
        var obj={},ObjArray=[]
        for(var i in THIS.assignation.evaluation){
          if(typeof obj[THIS.assignation.evaluation[i].id_code_evaluationmenues]==='undefined'){
           var text=''
           if(THIS.assignation.evaluation[i].id_code_questions==1){
             text=THIS.assignation.evaluation[i].Formulario+'(Reflexión)'
           }else{
            text=THIS.assignation.evaluation[i].Formulario
          }
          obj[THIS.assignation.evaluation[i].id_code_evaluationmenues]=text
          if(dataReturn.data.manatory[THIS.assignation.evaluation[i].id_code_evaluationmenues]==false){
           ObjArray.push(text)
         }

       }
     }

     for(var i in THIS.assignation.options){
      if(typeof obj[THIS.assignation.options[i].id_code_evaluationmenues]==='undefined'){
       obj[THIS.assignation.options[i].id_code_evaluationmenues]=THIS.assignation.options[i].Formulario
       if(dataReturn.data.manatory[THIS.assignation.options[i].id_code_evaluationmenues]==false){
        ObjArray.push(THIS.assignation.options[i].Formulario)
      }

    }
  }

  THIS.mandatoryFieldWarningModal(ObjArray)
}

}
},function (data) {
  console.log('sample vignesh',data)
})

   } 

   getNotifyEndExecution(idUser, notificationType){
      return {
            idUser: idUser ,
            dsName: 'Notificación, ejecución finalizada',
            dsDescription: 'El profesor ' + this.cookiesUser.dsFullname + ' ha finalizado la ejecución',
            idNotification_delivery_type: notificationType,
            is_grouped: 0
      }
    }


    mandatoryFieldWarningModal (details) {


        this.$mdDialog.show({
          controller: ['$scope', '$mdDialog', function mandatoryFieldWarningModal ($scope, $mdDialog) {
             $scope.data = details
            $scope.close = function () {
              $mdDialog.hide()
            }
          }],
          template: require('./model/mandatoryFieldWarningModal.html'),
          clickOutsideToClose: false
        })
      }

    endProcessModal () {

        var THIS=this

        this.$mdDialog.show({
          controller: ['$scope', '$mdDialog','GlobalConfig','WorkPlanSrv','WorkPlanModalSrv','GlobalSrv','$state', function mandatoryFieldWarningModal ($scope, $mdDialog,GlobalConfig,WorkPlanSrv,WorkPlanModalSrv,GlobalSrv,$state) {
            // $scope.data = response

        const headData = WorkPlanModalSrv.getVariable()


        const teacherId = THIS.cookiesUser.teacherId
        const workplanId = THIS.cookiesUser.workplanId
        const userId = THIS.cookiesUser.id
        const stageId = GlobalConfig.workplanIdStages.execution
          let header = {
          workplanId: workplanId,
          teacherId: teacherId,
          stageId: stageId,
          userId: userId,
          feedback:''
          }



            $scope.close = function () {
              $mdDialog.hide()
            }

            $scope.finilize=function(){

               WorkPlanSrv.endPlanning.post(header).$promise.then((dataReturn) => {
                   if (dataReturn.status) {
                        // executionFinish = true
                        GlobalSrv.sendNotification(THIS.getNotifyEndExecution(header.userId, THIS.GlobalConfig.notificationType.inbox))
                        GlobalSrv.sendNotification(THIS.getNotifyEndExecution(header.userId, THIS.GlobalConfig.notificationType.email))
                         
                          let reviewers = GlobalSrv.getReviewersAndEvaluator()
                          reviewers.forEach((reviewer) => {
                            GlobalSrv.sendNotification(THIS.getNotifyEndExecution(header.userId, THIS.GlobalConfig.notificationType.inbox))
                            GlobalSrv.sendNotification(THIS.getNotifyEndExecution(header.userId, THIS.GlobalConfig.notificationType.email))
                          })

                         
                         THIS.finalDialog()
                         close()
                        // $state.go('workplan.executionHistory'); 
                }
              })

              $mdDialog.hide()
            }
          }],
          template: require('./model/endProcessModal.html'),
          clickOutsideToClose: false
        })
      }


      finalDialog(){
          

         this.$mdDialog.show({
          controller: ['$scope', '$mdDialog','$state', function mandatoryFieldWarningModal ($scope, $mdDialog,$state) {
             // $scope.data = details
            $scope.close = function () {
               $mdDialog.hide()
               $state.go('workplan.executionHistory'); 
            }
          }],
          template: require('./model/finalDialogModal.html'),
          clickOutsideToClose: false
        })




      }

changeTab (id) {
    let selector = "#"+id
    $('#tabpanel').children().removeClass('active')
    $(selector).addClass('active')
    $('#tabcontent').children().removeClass('active')
    $(selector+'-btn').addClass( 'active' )
    this.$location.hash('top')
    this.$anchorScroll()
}





  }

  teacherSelfAssessmentController.$inject = ['$scope', '$state', '$stateParams', 'ngNotify', '$timeout', 'UserInfoConstant','integralEvaluationSrv','$cookies','GlobalConfig','WorkPlanSrv','$mdDialog', '$location', '$anchorScroll']


// WEBPACK FOOTER //
// ./src/app/u-faculty/integralEvaluation/teacherSelfAssessment/teacherSelfAssessmentController.js